import type { IconProps } from '../icons'

// ============================================================================
// The five glyphs LifeOS Calendar.dc.html draws that ../icons.tsx does not already carry.
// Same idiom, same rules: viewBox 0 0 24 24, fill none, stroke="currentColor" so the colour
// comes from a token class and never from a prop (which is also what keeps the ship gate's
// brand audit satisfiable — a raw hex in here would fail the build).
//
// Paths are transcribed from the mockup's own inline SVG, not redrawn.
// ============================================================================

function Glyph({ size = 13, strokeWidth = 2, className, d }: IconProps & { d: string }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
      focusable="false"
    >
      <path d={d} />
    </svg>
  )
}

/** The week/day stepper's back arrow. */
export const ChevronLeft = (p: IconProps) => <Glyph {...p} d="M14.5 5.5 8 12l6.5 6.5" />
/** …and forward. */
export const ChevronRight = (p: IconProps) => <Glyph {...p} d="M9.5 5.5 16 12l-6.5 6.5" />

/** The `New` button's plus. */
export const Plus = (p: IconProps) => <Glyph strokeWidth={2.4} {...p} d="M12 5.5v13M5.5 12h13" />

/**
 * The padlock beside FROM CANVAS at day-view size. The brief calls it optional; it is drawn
 * because a two-word label plus a lock reads as "you cannot move this" at a glance, and the
 * alternative — an affordance that looks disabled — is the thing rule 1 forbids.
 */
export const Lock = (p: IconProps) => (
  <Glyph strokeWidth={1.9} {...p} d="M7.4 10.6V8a4.6 4.6 0 0 1 9.2 0v2.6M6 10.6h12v8.4H6z" />
)

/** The six-dot drag grip on an unscheduled task row. */
export const Grip = (p: IconProps) => (
  <Glyph {...p} d="M8 8h.01M8 12h.01M8 16h.01M16 8h.01M16 12h.01M16 16h.01" />
)

/** The tick inside a checked source swatch. */
export const SourceCheck = (p: IconProps) => (
  <Glyph size={8} strokeWidth={3.4} {...p} d="M5 12.6l4 4L19 7.2" />
)

/** The detail peek's own close button — light dismiss, same glyph idiom as the rest of the file. */
export const PeekClose = (p: IconProps) => <Glyph size={11} strokeWidth={2.2} {...p} d="M6 6l12 12M18 6L6 18" />

